// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-action-list {
  width: calc(100% + 20px);
  margin-left: -10px;
}
.srprs-action-list + div {
  width: calc(100% + 20px);
  margin-left: -10px;
}
.srprs-action-list .srprs-list-item {
  width: 100%;
  display: block;
  background-color: #fff;
  border-style: solid;
  border-color: #e7e7e7;
  font-size: 15px;
  padding-top: 15px;
  padding-right: 0;
  padding-bottom: 10px;
  padding-left: 0;
  table-layout: fixed;
  transition-property: transform;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
}
.srprs-action-list .srprs-list-item::after {
  clear: both;
  content: "";
  display: table;
}
.srprs-action-list .srprs-list-item:hover {
  border-bottom-width: 1px;
}
.srprs-action-list .srprs-list-item:hover + li {
  margin-top: -1px;
}
.srprs-action-list .srprs-list-item:hover .srprs-button:not(.type-lock) {
  background-color: var(--colorBackground);
}
.srprs-action-list .srprs-list-item:not(.locked):hover {
  cursor: pointer;
  transform: scale(1.025);
}
.srprs-action-list .srprs-list-item.locked {
  cursor: not-allowed;
}
.srprs-action-list .srprs-list-item + li {
  border-top-width: 1px;
}
.srprs-action-list .srprs-list-item > .srprs-icon:first-child {
  width: 60px;
  height: 46px;
  float: left;
  padding-top: 10px;
  text-align: center;
}
.srprs-action-list .srprs-list-item > .srprs-icon:first-child svg {
  width: auto;
  height: 28px;
  display: inline-block;
}
.srprs-action-list .srprs-list-item > div:nth-child(2) {
  width: calc(100% - 92px - 50px);
  float: left;
  color: #222;
  line-height: 0;
  padding-top: 8px;
  text-transform: uppercase;
}
.srprs-action-list .srprs-list-item > div:nth-child(2) > span {
  width: 100%;
  display: inline-block;
  line-height: 1.375em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.srprs-action-list .srprs-list-item > div:nth-child(2) > span > i {
  text-transform: lowercase;
}
.srprs-action-list .srprs-list-item > div:nth-child(2) > span strong {
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
}
.srprs-action-list .srprs-list-item > div:nth-child(2) > span:first-child {
  font-size: 0.8em;
}
.srprs-action-list .srprs-list-item > .srprs-button:last-child {
  float: right;
  --borderWidth: 0px;
  padding-right: 12px;
  padding-left: 18px;
  text-transform: uppercase;
}
.srprs-action-list .srprs-list-item > .srprs-button:last-child.cutOff-right .srprs-icon {
  margin-left: 0;
}
.srprs-action-list .srprs-list-item > .srprs-button:last-child:hover {
  transform: none;
}
.srprs-action-list .srprs-list-item > .srprs-button:last-child i {
  display: none;
}
.srprs-action-list .srprs-list-item > .srprs-button:last-child.type-lock {
  margin-top: 2px;
  margin-right: 10px;
  padding-left: 13px;
}
.srprs-action-list .srprs-list-item > .override {
  float: right;
  margin-top: 2px;
  margin-right: 10px;
}
.srprs-action-list .srprs-list-item > .override > .srprs-icon {
  margin-top: 15px;
  margin-right: 10px;
}
.srprs-action-list .srprs-list-item .sub-value {
  text-transform: lowercase;
}
.srprs-action-list .srprs-small-list-item > div:nth-child(2) {
  width: min-content;
}

.srprs-small-action-list {
  width: auto;
  margin-left: unset;
}

@media screen and (min-width: 375px) {
  .srprs-action-list .srprs-list-item > .srprs-icon:first-child {
    width: 70px;
    height: 54px;
    padding-top: 8px;
  }
  .srprs-action-list .srprs-list-item > .srprs-icon:first-child svg {
    height: 32px;
  }
  .srprs-action-list .srprs-list-item > div:nth-child(2) {
    width: calc(100% - 92px - 92px);
  }
  .srprs-action-list .srprs-list-item > .srprs-button:last-child {
    width: auto;
    padding-left: 1.75em;
    padding-right: 1.5em;
  }
  .srprs-action-list .srprs-list-item > .srprs-button:last-child i {
    display: inline-block;
  }
  .srprs-action-list .srprs-list-item > .srprs-button:last-child.type-lock {
    margin-top: 4px;
    margin-right: 15px;
    padding-right: 13px;
    padding-left: 13px;
  }
  .srprs-action-list .srprs-list-item > .srprs-tooltip {
    margin-top: 4px;
    margin-right: 15px;
  }
  .srprs-action-list .srprs-list-item:not(.locked) > .srprs-button:last-child .srprs-icon {
    display: none;
  }
}
@media screen and (min-width: 640px) {
  .srprs-action-list .srprs-list-item {
    box-shadow: 0 0 12px 0 rgba(34, 34, 34, 0.15);
    border: none;
    font-size: 18px;
    padding-top: 22px;
    padding-bottom: 22px;
  }
  .srprs-action-list .srprs-list-item:hover + li {
    margin-top: 10px;
  }
  .srprs-action-list .srprs-list-item > .srprs-icon:first-child {
    width: 90px;
    padding-top: 6px;
  }
  .srprs-action-list .srprs-list-item > .srprs-icon:first-child svg {
    height: 38px;
  }
  .srprs-action-list .srprs-list-item > div:nth-child(2) {
    width: calc(100% - 90px - 126px);
    border-left-width: 1px;
    border-style: solid;
    border-color: #e7e7e7;
    padding-right: 20px;
    padding-left: 20px;
  }
  .srprs-action-list .srprs-list-item + div + li, .srprs-action-list .srprs-list-item + li, .srprs-action-list .srprs-list-item + .srprs-grid > li {
    margin-top: 10px;
  }
}
@media screen and (min-width: 768px) {
  .srprs-action-list {
    width: 100%;
    margin-left: 0;
  }
  .srprs-action-list + div {
    width: 100%;
    margin-left: 0;
  }
  .srprs-action-list .srprs-list-item > div:nth-child(2) {
    width: calc(100% - 90px - 130px);
  }
  .srprs-action-list .srprs-list-item > .srprs-button:last-child.type-lock {
    margin-top: 8px;
  }
  .srprs-action-list .srprs-list-item > .srprs-tooltip {
    margin-top: 8px;
  }
  .srprs-action-list .srprs-small-list-item > div:nth-child(2) {
    width: min-content;
  }
  .srprs-action-list .srprs-grid .srprs-list-item > div:nth-child(2) {
    width: calc(100% - 90px - 60px);
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/ActionList/ActionList.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_clearfix.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_box-shadow.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AApMA;EACE,wBAAA;EAEE,kBAAA;AAqMJ;AAlME;EAEE,wBAAA;EAEE,kBAAA;AAkMN;AA9LE;EAEE,WAAA;EACA,cAAA;EAEE,sBAAA;EAGA,mBAAA;EACA,qBAAA;EAGA,eAAA;EAGA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EAGA,mBAAA;EAGA,8BAAA;EACA,0BAAA;EACA,oCAAA;AAoLN;AI9NE;EACE,WAAA;EACA,WAAA;EACA,cAAA;AJgOJ;AAtLI;EAEI,wBAAA;AAuLR;AArLM;EACE,gBAAA;AAuLR;AApLQ;EAEI,wCAAA;AAqLZ;AAhLI;EACE,eAAA;EACA,uBAAA;AAkLN;AAhLI;EACE,mBAAA;AAkLN;AAhLI;EAEI,qBAAA;AAiLR;AA9KI;EACE,WAAA;EACA,YAAA;EACA,WAAA;EAEE,iBAAA;EAGA,kBAAA;AA6KR;AA3KM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AA6KR;AA1KI;EACE,+BAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EAEE,gBAAA;EAGA,yBAAA;AAyKR;AAvKM;EACE,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EAEE,uBAAA;AAwKV;AAtKQ;EAEI,yBAAA;AAuKZ;AApKQ;EACE,2IAAA;AAsKV;AApKQ;EAEI,gBAAA;AAqKZ;AAhKI;EACE,YAAA;EACA,kBAAA;EAEE,mBAAA;EACA,kBAAA;EAGA,yBAAA;AA+JR;AA5JQ;EAEI,cAAA;AA6JZ;AAzJM;EACE,eAAA;AA2JR;AAzJM;EACE,aAAA;AA2JR;AAzJM;EAEI,eAAA;EACA,kBAAA;EAGA,kBAAA;AAwJV;AAnJI;EACE,YAAA;EAEE,eAAA;EACA,kBAAA;AAoJR;AAlJM;EAEI,gBAAA;EACA,kBAAA;AAmJV;AA/II;EAEI,yBAAA;AAgJR;AA1II;EACE,kBAAA;AA4IN;;AAvIA;EACE,WAAA;EACA,kBAAA;AA0IF;;ACjUI;ED6LE;IACE,WAAA;IACA,YAAA;IAEE,gBAAA;EAuIR;EArIM;IACE,YAAA;EAuIR;EApII;IACE,+BAAA;EAsIN;EApII;IACE,WAAA;IAEE,oBAAA;IACA,oBAAA;EAqIR;EAnIM;IACE,qBAAA;EAqIR;EAnIM;IAEI,eAAA;IACA,kBAAA;IAGA,mBAAA;IACA,kBAAA;EAkIV;EA9HI;IAEI,eAAA;IACA,kBAAA;EA+HR;EA3HM;IACE,aAAA;EA6HR;AACF;ACpWI;ED8OF;IKtOE,6CAAA;ILwOA,YAAA;IAEE,eAAA;IAGA,iBAAA;IACA,oBAAA;EAsHJ;EApHE;IACE,gBAAA;EAsHJ;EApHE;IACE,WAAA;IAEE,gBAAA;EAqHN;EAnHI;IACE,YAAA;EAqHN;EAlHE;IACE,gCAAA;IAEE,sBAAA;IACA,mBAAA;IACA,qBAAA;IAGA,mBAAA;IACA,kBAAA;EAiHN;EA9GE;IAII,gBAAA;EA6GN;AACF;AClYI;ED2RF;IACE,WAAA;IAEE,cAAA;EAyGJ;EAtGE;IACE,WAAA;IAEE,cAAA;EAuGN;EAlGI;IACE,gCAAA;EAoGN;EAhGM;IAEI,eAAA;EAiGV;EA7FI;IAEI,eAAA;EA8FR;EAzFI;IACE,kBAAA;EA2FN;EAtFI;IACE,+BAAA;EAwFN;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","$cdn-url: 'https://store.cdn.srprs.me/';\n@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n\n.srprs-action-list {\n  width: calc(100% + 20px);\n  margin: {\n    left: -10px;\n  }\n\n  & + div {\n    // ugh\n    width: calc(100% + 20px);\n    margin: {\n      left: -10px;\n    }\n  }\n\n  .srprs-list-item {\n    @include clearfix;\n    width: 100%;\n    display: block;\n    background: {\n      color: color(white);\n    }\n    border: {\n      style: solid;\n      color: color(grey-light);\n    }\n    font: {\n      size: 15px;\n    }\n    padding: {\n      top: 15px;\n      right: 0;\n      bottom: 10px;\n      left: 0;\n    }\n    table: {\n      layout: fixed;\n    }\n    transition: {\n      property: transform;\n      duration: 0.25s;\n      timing-function: ease-out;\n    }\n    // States\n    &:hover {\n      border: {\n        bottom-width: 1px;\n      }\n      & + li {\n        margin-top: -1px;\n      }\n      .srprs-button {\n        &:not(.type-lock) {\n          background: {\n            color: var(--colorBackground);\n          }\n        }\n      }\n    }\n    &:not(.locked):hover {\n      cursor: pointer;\n      transform: scale(1.025);\n    }\n    &.locked {\n      cursor: not-allowed;\n    }\n    & + li {\n      border: {\n        top-width: 1px;\n      }\n    }\n    > .srprs-icon:first-child {\n      width: 60px;\n      height: 46px;\n      float: left;\n      padding: {\n        top: 10px;\n      }\n      text: {\n        align: center;\n      }\n      svg {\n        width: auto;\n        height: 28px;\n        display: inline-block;\n      }\n    }\n    > div:nth-child(2) {\n      width: calc((100% - 92px) - 50px);\n      float: left;\n      color: color(black);\n      line-height: 0;\n      padding: {\n        top: 8px;\n      }\n      text: {\n        transform: uppercase;\n      }\n      > span {\n        width: 100%;\n        display: inline-block;\n        line-height: 1.375em;\n        overflow: hidden;\n        white-space: nowrap;\n        text: {\n          overflow: ellipsis;\n        }\n        > i {\n          text: {\n            transform: lowercase;\n          }\n        }\n        strong {\n          font-family: font(heading);\n        }\n        &:first-child {\n          font: {\n            size: 0.8em;\n          }\n        }\n      }\n    }\n    > .srprs-button:last-child {\n      float: right;\n      --borderWidth: 0px;\n      padding: {\n        right: 12px;\n        left: 18px;\n      }\n      text: {\n        transform: uppercase;\n      }\n      &.cutOff-right {\n        .srprs-icon {\n          margin: {\n            left: 0;\n          }\n        }\n      }\n      &:hover {\n        transform: none;\n      }\n      i {\n        display: none;\n      }\n      &.type-lock {\n        margin: {\n          top: 2px;\n          right: 10px;\n        }\n        padding: {\n          left: 13px;\n        }\n      }\n    }\n\n    > .override {\n      float: right;\n      margin: {\n        top: 2px;\n        right: 10px;\n      }\n      > .srprs-icon {\n        margin: {\n          top: 15px;\n          right: 10px;\n        }\n      }\n    }\n    .sub-value {\n      text: {\n        transform: lowercase;\n      }\n    }\n  }\n\n  .srprs-small-list-item {\n    > div:nth-child(2) {\n      width: min-content;\n    }\n  }\n}\n\n.srprs-small-action-list {\n  width: auto;\n  margin-left: unset;\n}\n\n@include breakpoint(mobile-large) {\n  .srprs-action-list {\n    .srprs-list-item {\n      > .srprs-icon:first-child {\n        width: 70px;\n        height: 54px;\n        padding: {\n          top: 8px;\n        }\n        svg {\n          height: 32px;\n        }\n      }\n      > div:nth-child(2) {\n        width: calc((100% - 92px) - 92px);\n      }\n      > .srprs-button:last-child {\n        width: auto;\n        padding: {\n          left: 1.75em;\n          right: 1.5em;\n        }\n        i {\n          display: inline-block;\n        }\n        &.type-lock {\n          margin: {\n            top: 4px;\n            right: 15px;\n          }\n          padding: {\n            right: 13px;\n            left: 13px;\n          }\n        }\n      }\n      > .srprs-tooltip {\n        margin: {\n          top: 4px;\n          right: 15px;\n        }\n      }\n      &:not(.locked) > .srprs-button:last-child {\n        .srprs-icon {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n@include breakpoint(mobile-landscape) {\n  .srprs-action-list .srprs-list-item {\n    @include box-shadow();\n    border: none;\n    font: {\n      size: 18px;\n    }\n    padding: {\n      top: 22px;\n      bottom: 22px;\n    }\n    &:hover + li {\n      margin-top: 10px;\n    }\n    > .srprs-icon:first-child {\n      width: 90px;\n      padding: {\n        top: 6px;\n      }\n      svg {\n        height: 38px;\n      }\n    }\n    > div:nth-child(2) {\n      width: calc((100% - 90px) - 126px);\n      border: {\n        left-width: 1px;\n        style: solid;\n        color: color(grey-light);\n      }\n      padding: {\n        right: 20px;\n        left: 20px;\n      }\n    }\n    & + div + li,\n    & + li,\n    & + .srprs-grid > li {\n      margin: {\n        top: 10px;\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-action-list {\n    width: 100%;\n    margin: {\n      left: 0;\n    }\n\n    & + div {\n      width: 100%;\n      margin: {\n        left: 0;\n      }\n    }\n\n    .srprs-list-item {\n      > div:nth-child(2) {\n        width: calc((100% - 90px) - 130px);\n      }\n\n      > .srprs-button:last-child {\n        &.type-lock {\n          margin: {\n            top: 8px;\n          }\n        }\n      }\n      > .srprs-tooltip {\n        margin: {\n          top: 8px;\n        }\n      }\n    }\n    .srprs-small-list-item {\n      > div:nth-child(2) {\n        width: min-content;\n      }\n    }\n\n    .srprs-grid .srprs-list-item {\n      > div:nth-child(2) {\n        width: calc((100% - 90px) - 60px);\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin clearfix {\n  &::after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n}\n","@charset \"UTF-8\";\n\n$box-shadow: map-deep-get($srprsreactwebsite-config, 'box-shadow');\n\n@mixin box-shadow(\n  $blur: map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n) {\n  @if map-has-key($box-shadow, $blur) {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', $blur)\n      0\n      rgba(color(black), 0.15);\n  } @else {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n      0\n      rgba(color(black), 0.15);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
